<template>
  <form class="check-register" @submit.prevent="authorize">
    <p>
      {{ $t("modals.login.registration_start_subtitle") }}
    </p>
    <div class="register-input">
      <p class="register-text">
        Please add the following phrase to your Roblox description page
      </p>
      <div class="copy-text">
        <p ref="referralLink">{{ state.description }}</p>
        <i @click="copyDescription"><SmallCopyIcon /></i>
      </div>
      <div class="check-error" v-if="state.errors.phrase?.length">
        <i><DangerTriangle /></i>
        <p v-for="error in state.errors.phrase" :key="error">
          {{ error }}
        </p>
      </div>
    </div>
    <div class="check">
      <!-- eslint-disable-next-line vue/no-mutating-props -->
      <ToggleInput v-model="state.terms_and_policy" />
      <p>
        By checking this box you agree to our
        <TermsModalWithButton />
      </p>
    </div>
    <Button
      :disabled="!state.terms_and_policy || authorizing"
      action="submit"
      type="primary"
      style="width: 100%; height: 52px"
    >
      Sign up
    </Button>
  </form>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import indexMixin from "@/components/login/mixins"

export default defineComponent({
  name: "CheckRegisterDesktop",
  mixins: [indexMixin],
})
</script>

<style lang="scss" scoped>
.check-register {
  display: flex;
  flex-direction: column;
  gap: 24px;
  p {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: -0.4px;
    color: rgba(255, 255, 255, 0.8);
    max-width: 436px;
  }
  .register-input {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    .copy-text {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 14px 16px;
      gap: 10px;
      width: calc(100% - 32px);
      background: rgba(255, 255, 255, 0.04);
      border-radius: 12px;
      p {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #ffffff;
        text-align: start;
      }
      i {
        cursor: pointer;
      }
    }
    .register-text {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      text-align: start;
      letter-spacing: -0.4px;
      color: #ffffff;
    }
  }
  .check {
    display: flex;
    gap: 8px;
    align-items: center;
    p {
      font-family: "Montserrat";
      max-width: 233px;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      text-align: start;
      letter-spacing: -0.4px;
      color: rgba(255, 255, 255, 0.6);
      max-width: 233px;
      a {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
}
.check-error {
  display: flex;
  justify-content: start;
  align-items: start;
  gap: 8px;
  p {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: #ff0000;
    text-align: start;
  }
}
</style>
